/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import Header from './standard-page-header.js';
import AuthenticationStore from '../../store/authentication-store.js';
import { Button , Modal } from 'react-bootstrap';
import Navigation from './navigation.js';
import SearchService from '../../services/search-service.js';
import CardBody from '../card-body.js';
import Card from '../card.js';
import {Link} from 'react-router';
export default class StandardLayout extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {timeout:false , menuToggled:false , hasSearchResults:false}
        this.forceMenuClose = this.forceMenuClose.bind(this);
    }

    componentWillMount(){
        document.getElementsByTagName("body")[0].setAttribute("data-ma-header", "brand");
        AuthenticationStore.on('WARNING_USER' , () => {
            alert(AuthenticationStore.warning);
           this.setState({timeout:AuthenticationStore.warning})
        });
    }

    componentDidMount() {
        window.addEventListener("resize"   ,  this.forceMenuClose);
    }

    componentWillUnmount() {
        window.removeEventListener("resize",  this.forceMenuClose);
    }

    handelToggle(){
        this.setState({menuToggled:!this.state.menuToggled})
    }

    forceMenuClose(){
        this.setState({menuToggled:false})
    }

    onSearch(value){

        if(value.length <= 1) return   this.setState({hasSearchResults:false , searchResults:[]});

        SearchService.globalSearch(value).then(function(results){
            var totalresults = results.students.length + results.classes.length;
            this.setState({hasSearchResults:totalresults > 0 , searchResults:results})
        }.bind(this));
    }

    constructSearchList(){

        var students = [];
        for(var idx = 0 ; idx < this.state.searchResults.students.length; idx++){
            var name = this.state.searchResults.students[idx].name;
            var classes = this.state.searchResults.students[idx].classes.map(function(_class){
                return <span><small>{_class.name}</small></span>
            });

            students.push (
                <Link to={'student/profile/'+this.state.searchResults.students[idx].uid}>
                <div key={"letter-"+name+Math.random()} className="list-group-item media">
                    <div className="checkbox pull-left lgi-checkbox">
                        <div className="pull-left">
                            <div className="avatar-char palette-Light-Blue bg">{name[0]}</div>
                        </div>
                        <div className="media-body p-l-5">
                            <div className="lgi-heading">{name}</div>
                            {classes}
                        </div>
                    </div>
                </div></Link>)
        }

        var classes = [];
        for(var idx = 0 ; idx < this.state.searchResults.classes.length; idx++){
            var name = this.state.searchResults.classes[idx].name;

            classes.push (
                <Link to={'class/profile/'+this.state.searchResults.classes[idx].uid}>
                <div key={"letter-"+name+Math.random()} className="list-group-item media">
                    <div className="checkbox pull-left lgi-checkbox">
                        <div className="pull-left">
                            <div className="avatar-char palette-Light-Blue bg">{name[0]}</div>
                        </div>
                        <div className="media-body p-l-5">
                            <div className="lgi-heading">{name}</div>
                        </div>
                    </div>
                </div></Link>)
        }



        return <Card><CardBody><div className="list-group lg-alt lg-even-black">{classes} {students}</div></CardBody></Card>
    }

    render(){

        let body = this.state.hasSearchResults ? this.constructSearchList() : this.props.children
        return (<div>
            <Modal show={this.state.timeout}>
                <Modal.Header closeButton>
                    <Modal.Title>You have been idle for a while</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    You will be automaticaly logged you out in about 5 mins
                </Modal.Body>
                <Modal.Footer>
                    <Button >Stay Logged In</Button>
                </Modal.Footer>
            </Modal>
                    <Header onSearch={this.onSearch.bind(this)} handelToggle={this.handelToggle.bind(this)} toggle={this.state.menuToggled}/>
                    <section id="main">
                        <Navigation handelToggle={this.handelToggle.bind(this)} toggle={this.state.menuToggled}/>
                        <section id="content">
                            {body}
                        </section>
                    </section>
                </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/standard-page.js